import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { FinancialStatement } from "../Entities/FinancialStatement/FinancialStatement";
import { FinancialStatementInterface } from "../Entities/FinancialStatement/FinancialStatementInterface";
import Store from "../../Store/Store";

class FinancialStatementFactory extends Factory implements FactoryInterface {
  public create(data: any): FinancialStatementInterface {
    return new FinancialStatement({
      id: data.id,
      // carriedFromLastMonth: data.carriedFromLastMonth, // deprecated: was found not to be used 
      // carry: data.carry,  // deprecated: carry info is no longer presented nor used otherwise
      companyId: data.companyId,
      statement: data.statement,
      payout: data.payout,
      creationDate: new Date(data.creationDate),
      period: new Date(data.period),
      type: Store.getConfigurator().getState().globalTypes?.FinancialStatementType?.[data.type],
      removable: data.removable,
      removed: data.removed,
      firstDate: new Date(data.firstDate),
      lastDate: new Date(data.lastDate),
      ownerId: data.ownerId,
      periodId: data.periodId,
      balanceId: data.balanceId,
      balance: data.balance,
      status: Store.getConfigurator().getState().globalTypes?.FinancialStatementStatuses?.[data.statusId],
      isSent: data.isSent,
      isSnoozed: data.isSnoozed,
      actualPayoutChargeId: data.actualPayoutChargeId,
      readinessStatusId: data.readinessStatusId,
      hasMemos: data.hasMemos,
      result: data.balance?.result,
      updatedAt: new Date(data.updatedAt),
      data: data.data,
      locked: data.locked,
    });
  }

  public reinitialize(data: any): FinancialStatementInterface {
    return new FinancialStatement({
      ...data
    });
  }
}

export default new FinancialStatementFactory();
